import { Loader2 } from "lucide-react";
import { BackgroundOrbs } from "@/components/shared/ui/BackgroundOrbs";

export function RouteHydrateFallback() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <BackgroundOrbs />
      <Loader2 size={32} className="relative z-10 animate-spin text-[#003366]" />
    </div>
  );
}
